/**
 * Given a sphere and a system_name, returns an array of assigned subject spheres
 * that match the system_name in that sphere's assignedPerspectives.
 *
 * @param {Object} sphere - The sphere object, which may contain assignedPerspectives.
 * @param {string} systemName - The system_name to look for (e.g. "center_parent").
 * @returns {Object[]} - An array of assigned subject "sphere" objects. Empty array if none found.
 */
import { Sphere } from 'types/global';

export function getAssignedSubjectsBySystemName(sphere: Sphere, systemName: string) {
    if (!sphere || !Array.isArray(sphere.assignedPerspectives)) {
      return [];
    }
  
    // Find the perspective with the matching system_name
    const matchedPerspective = sphere.assignedPerspectives.find(
      (perspective) => perspective?.perspectiveProperties?.system_name === systemName
    );
  
    if (!matchedPerspective || !Array.isArray(matchedPerspective.assigned)) {
      return [];
    }
  
    // Return *all* assigned subject spheres (filter out any null/undefined)
    return matchedPerspective.assigned.map((item) => item?.sphere).filter(Boolean);
  }
  